module.exports = __webpack_public_path__ + "media/customizations/cotavera/logo-6fbf3632c37903ebe2fce39e91089930.png";